import useAsyncData from "../../../../hooks/use-async-data";
import orderService from "../../order.service";
import OrderCargoOrderDetailsHandlingLog from "./order-cargo-order-details-handling-log";
import OrderCargoOrderDetailsHandlingLogParams from "./order-cargo-order-details-handling-log-params";

const useOrderCargoOrderDetailsHandlingLog = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<OrderCargoOrderDetailsHandlingLog>({
      data: [],
    });

  const load = async (
    params: OrderCargoOrderDetailsHandlingLogParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoOrderDetailsHandlingLogData =
        await orderService.getHandlingLog(params, signal);

      setData(cargoOrderDetailsHandlingLogData);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useOrderCargoOrderDetailsHandlingLog;
